// ● チップの合計枚数を計算し、注意メッセージを表示する
function calcTotalTip() {
  let tipNum = [];
  $('[id*="tip_number_"]').each(function() {
    tipNum.push($(this).val());
  });

  let tipTotalNum = tipNum.filter(v => v).reduce(function(sum, element){
    return sum + parseInt(element, 10);
  }, 0);

  // 計算結果の符号を逆にする
  let invertedTipTotalNum = -tipTotalNum;

  const remainingScoreElement = document.getElementById('js-remaining-tip');

  // チップ合計枚数を表示
  if (remainingScoreElement) {
    remainingScoreElement.textContent = invertedTipTotalNum;
    if (invertedTipTotalNum !== 0) {
      remainingScoreElement.classList.add('text-minus');
    } else {
      remainingScoreElement.classList.remove('text-main');
    }
  }

  return invertedTipTotalNum;
}


$(document).on('turbolinks:load', function () {
  // ページ読み込み時にチップ合計枚数を計算
  calcTotalTip();
  // チップ枚数入力時にチップ合計枚数を計算
  $('[id*="tip_number_"]').on('input', calcTotalTip);
  // チップ登録ボタンクリック時にチップ合計枚数がゼロでない場合、確認メッセージ出力
  $('#tip_create_btn').on('click', function() {
    let totalTip = calcTotalTip()
    if (totalTip !== 0) {
      var confirmMsg = $('#tip_create_btn').data('unbalanced-confirm');
      if (!window.confirm(confirmMsg)) {
        return false;
      }
    }
  });
});
